import { HrTextInputProps } from "../atoms/HrTextInput";
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import { styled, TextField, TextFieldProps, FormControl } from "@mui/material";
import { Colors } from "../../constants/colors";
import { useReactiveVar } from "@apollo/client";
import { disableForStatus } from "../../stores/ReactiveVariables";


type PercentInputProps ={
  decimalScale?: number;
} & NumericFormatProps & TextFieldProps & HrTextInputProps;

const CurrencyInput = ({ value, onChange, onBlur, ...props}: PercentInputProps) => {
  const disabledForStatus = useReactiveVar(disableForStatus);

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    const parsedValue = value.replace(/[^0-9.]/g, '');
    onChange && onChange({ ...e, target: {  ...e.target, value: parsedValue, name } });
  }

  const handleOnBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { value, name } = e.target;
    const parsedValue = value.replace(/[^0-9.]/g, '');
    onBlur && onBlur({ ...e, target: {  ...e.target, value: parsedValue, name } });
  }

  return(
    <FormControl fullWidth={props.fullWidth}>
        <NumericFormat
          {...props}
          value={value} 
          allowLeadingZeros 
          thousandSeparator="," 
          decimalScale={props.decimalScale ?? 2} 
          fixedDecimalScale
          prefix="$ "
          style={props?.style}
          disabled={props?.disabled || disabledForStatus}
          size={props.size ?? 'small'} 
          onBlur={handleOnBlur}
          onChange={handleOnChange}
          width={props?.width}
          customInput={TextField}
          valueIsNumericString
          />
    </FormControl>
  )
}

export const HrCurrencyInput = styled(CurrencyInput)(({ width }) => ({
    '.MuiInputBase-root': {
        fontWeight:500,
        'legend': {
            fontSize:".95rem"
        }
    },
    '.MuiInputLabel-shrink ':{
        transform:"translate(14px, -11px) scale(.75)!important",
        fontSize:"1.3rem",
        //fontWeight:500,
    },
  "& label.Mui-focused": {
      color: Colors.black,
  },
  "& label": {
      color: Colors.black,
      fontFamily: "Montserrat"
  },
  "& .MuiInput-underline:after": {
      borderBottomColor: Colors.black,
  },
  "& .MuiOutlinedInput-root": {
      fontFamily: "Montserrat",
      "& fieldset": {
          borderColor: Colors.darkSeaGreen,
      },
      "&:hover fieldset": {
          borderColor: Colors.darkSeaGreen,
      },
      "&.Mui-focused fieldset": {
          borderColor: Colors.darkSeaGreen,
      },
      "&.Mui-error fieldset": {
          borderColor: Colors.errorRed,
      }
  },
  "& .MuiInputBase-root.Mui-disabled": {
      borderColor: Colors.darkSeaGreen,
      backgroundColor:Colors.unselectedGray,
      color: Colors.black,
      webkitTextFillColor: Colors.black,
      "&.Mui-error":{
          "&:hover fieldset": {
              borderColor: Colors.errorRed,
          },
          "& fieldset": {
              borderColor: Colors.errorRed,
          },  
      },
      "& fieldset": {
          borderColor: Colors.darkSeaGreen,
      },
      "&:hover fieldset": {
          borderColor: Colors.darkSeaGreen,
      },
      "&.Mui-focused fieldset": {
          borderColor: Colors.darkSeaGreen,
      },

  },
  "& label.Mui-disabled": {
      color: "black",
  },
  width: width
}));